import { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';

export const TerminalWindow = () => {
  const [input, setInput] = useState('');
  const [history, setHistory] = useState([
    { type: 'system', text: 'ALVIN\'S OS Terminal v2.0' },
    { type: 'system', text: 'Type "help" for available commands' },
    { type: 'prompt', text: '' }
  ]);
  const inputRef = useRef(null);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [history]);

  const commands = {
    help: () => [
      'Available commands:',
      '  help      - Show this help message',
      '  about     - Display information about me',
      '  skills    - List my technical skills',
      '  projects  - Show my projects',
      '  contact   - Display contact information',
      '  clear     - Clear the terminal',
      '  scan      - Run system scan',
      '  status    - Show system status'
    ],
about: () => [
      'ALVIN JO REGI - FULL STACK DEV & MEDIA SPECIALIST',
      'Location: SHARJAH, UNITED ARAB EMIRATES',
      'Expertise: WEB DEV, PHOTO/VIDEO & EVENT TECH',
    ],
    skills: () => [
      'Core Technologies:',
      '  • React, Node.js, JS, TS, HTML, CSS',
      '  • Python, Discord.js, Discord.py',
      '  • Photography & Professional Video Editing',
      '  • Sound & Light Engineering (Yamaha Digital Consoles)',
      '  • Arabic Language'
    ],
    projects: () => [
      'Featured Projects & Roles:',
      '  1. Pinnacle Event Organizing - Founder & CEO',
      '  2. TEDxSISJ Youth - Head of Event Operations',
      '  3. SIS FEST\'24 - Technical Lead',
      '  4. CSMS Season 3 - Head of Tech & Media',
      '  + More....'
    ],
    contact: () => [
      'Contact Information:',
      '  Email: alvinjoregi76@gmail.com',
      '  LinkedIn: linkedin.com/in/alvinjoregi',
      '  Instagram: instagram.com/alvincodez/'
    ],
        scan: () => [
      'Initiating system scan...',
      '[====================================] 100%',
      'Scan complete. All systems operational.',
      'Security level: MAXIMUM',
      'Threat level: NONE'
    ],
    status: () => [
      'System Status: ONLINE',
      'CPU Usage: 45%',
      'Memory: 12.4 / 32 GB',
      'Network: 850 Mbps',
    ],
    loginapi: () => {
  window.location.href = 'https://loginapi.gt.tc/';
  return [
    'Redirecting...',
    'Accessing secure endpoint...'
  ];
},

    clear: () => 'CLEAR'
  };

  const handleCommand = (cmd) => {
    const trimmedCmd = cmd.trim().toLowerCase();
    const output = commands[trimmedCmd];

    if (output) {
      if (output() === 'CLEAR') {
        setHistory([{ type: 'prompt', text: '' }]);
      } else {
        const newHistory = [
          ...history.slice(0, -1),
          { type: 'input', text: `$ ${cmd}` },
          ...output().map(text => ({ type: 'output', text })),
          { type: 'prompt', text: '' }
        ];
        setHistory(newHistory);
      }
    } else if (trimmedCmd) {
      const newHistory = [
        ...history.slice(0, -1),
        { type: 'input', text: `$ ${cmd}` },
        { type: 'error', text: `Command not found: ${cmd}. Type "help" for available commands.` },
        { type: 'prompt', text: '' }
      ];
      setHistory(newHistory);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleCommand(input);
      setInput('');
    }
  };

  return (
    <div 
      className="h-full bg-background/80 font-mono text-sm p-4 overflow-hidden flex flex-col"
      onClick={() => inputRef.current?.focus()}
    >
      <div ref={scrollRef} className="flex-1 overflow-y-auto scrollbar-tech space-y-1">
        {history.map((line, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.1 }}
            className="flex items-start gap-2"
          >
            {line.type === 'input' && (
              <span className="text-primary whitespace-pre-wrap">{line.text}</span>
            )}
            {line.type === 'output' && (
              <span className="text-foreground/80 whitespace-pre-wrap">{line.text}</span>
            )}
            {line.type === 'error' && (
              <span className="text-accent whitespace-pre-wrap">{line.text}</span>
            )}
            {line.type === 'system' && (
              <span className="text-success whitespace-pre-wrap">{line.text}</span>
            )}
            {line.type === 'prompt' && (
              <div className="flex items-center gap-2 w-full">
                <ChevronRight className="w-4 h-4 text-primary" />
                <input
                  ref={inputRef}
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={handleKeyDown}
                  className="flex-1 bg-transparent outline-none text-foreground"
                  autoFocus
                />
                <motion.span
                  animate={{ opacity: [1, 0] }}
                  transition={{ duration: 0.8, repeat: Infinity }}
                  className="w-2 h-4 bg-primary"
                />
              </div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default TerminalWindow;
